<template>
    <div>
        <div id="modal-move-patient" aria-hidden="true" aria-labelledby="modalFillInLabel" class="modal modal-note animation opacity" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <header class="modal-header">
                        <span v-if="patientID === null" class="h3">{{ __('Transfer of patients') }}</span>
                        <span v-else class="h3">{{ __('Patient transfer') }} - {{ patientName }}</span>

                        <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                            <svg-icon icon="close-modal" />
                        </button>
                    </header>

                    <div class="modal-body">
                        <form action="" class="" method="POST">
                            <slot></slot>
                            <div class="input-wrapper form-input-select basic-border">
                                <label for="old_coach" v-if="patientID === null">{{ __('Move all patients from:') }}</label>
                                <label for="old_coach" v-else>{{ __('Move the patient from:') }}</label>
                                <select name="" id="old_coach" ref="oldCoach" :title="__('Select a dietitian')" :disabled="patientID !== null">
                                    <option class="old_coach-option" v-for="coach in oldCoaches" :data-image="coach.user.avatar" :value="coach.id">
                                        <div class="content">
                                            <UserAvatar :user-info="coach.user" size="xs" />
                                            <span>{{ coach.user.fullname }}</span> 
                                        </div>
                                    </option>
                                </select>
                            </div>

                            <div class="input-wrapper form-input-select basic-border">
                                <label for="new_coach" v-if="patientID === null">{{ __('Move all patients to:') }}</label>
                                <label for="old_coach" v-else>{{ __('Move the patient to:') }}</label>
                                <select name="" id="new_coach" ref="newCoach" :title="__('Select a dietitian')" disabled>
                                    <option class="new_coach-option" v-for="coach in newCoaches" :data-image="coach.user.avatar" :value="coach.id">
                                        <div class="content">
                                            <UserAvatar :user-info="coach.user" size="xs" />
                                            <span>{{ coach.user.fullname }}</span> 
                                        </div>
                                    </option>
                                </select>
                            </div>

                            <div class="input-wrapper form-input-textarea">
                                <label for="message" class="">{{ __('[m] Chat message (from new dietitian)') }}</label> 
                                <textarea ref="textarea" id="message" v-model="message" name="message" :placeholder="__('Write a message')" class="basic-border" style="height: 0px;"></textarea>
                                <EmojiIcon :onEmojiPicked="onEmojiPicked" />
                            </div>

                            <VButton :disabled="sendButtonActive" :label="__('Move and send')" full-width modal-target="modal-move-patient-confirm" size="lg" />
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <PatientModalMovePatientConfirm :new-coach="newCoach" :old-coach="oldCoach" :patient="patientID"></PatientModalMovePatientConfirm>
    </div>
</template>

<script>
import PatientModalMovePatientConfirm from './PatientModalMovePatientConfirm.vue'
import EmojiIcon from '../../../chat/components/chat/emoji/EmojiIcon.vue'

export default {
    components: {
        PatientModalMovePatientConfirm,
        EmojiIcon
    },
    data() {
        return {
            oldCoaches: null,
            newCoaches: null,
            message: '',
            oldCoach: null,
            newCoach: null,
            patientID: null,
            patientName: '',
            cursorPosition: null
        }
    },
    computed: {
        sendButtonActive() {
            if (this.oldCoach && this.newCoach && this.message !== '') {
                return false
            } else {
                return true
            }
        }
    },
    watch: {
        newCoaches() {
            setTimeout(() => {
                $('#new_coach').prop('disabled', false)
                $('#new_coach').selectpicker('refresh')
            }, 200)
        },
        message: {
            immediate: true,
            handler(message) {
                const textarea = this.$refs.textarea

                if (this.autoGrow) {
                    setTimeout(() => {
                        if (textarea) {
                            this.cursorPosition = textarea.selectionStart

                            if (message === '') {
                                textarea.style.height = this.minHeight + 'px'
                            } else {
                                textarea.style.height = textarea.scrollHeight + 'px'
                                textarea.style.overflow = 'hidden'
                            }
                        }

                        if (this.maxlength > 0 && message.length === this.maxlength) {
                            this.errors[0] = lang.get('You have reached the maximum number of characters.')
                        }
                    }, 10)
                }

                if (message) {
                    this.hasError = false
                }

                this.$emit('input', message)
            }
        },
    },
    mounted() {
        const that = this
        this.fetchCoaches()

        const textarea = $("#message")

        textarea.on('click', function() {
            that.cursorPosition = textarea[0].selectionStart
        })

        textarea.on('keyup', function() {
            that.cursorPosition = textarea[0].selectionStart
        })

        $('#modal-move-patient').on('show.bs.modal', function (e) {
            $('select').selectpicker()

            if (e.relatedTarget.dataset.patientId) {
                that.patientID = parseInt(e.relatedTarget.dataset.patientId)
                that.patientName = e.relatedTarget.dataset.patientName
                that.oldCoach = parseInt(e.relatedTarget.dataset.coachId)

                $('#old_coach').selectpicker('val', that.oldCoach)
                $('#old_coach').prop('disabled', true)

                that.newCoaches = that.oldCoaches.filter(c => c.id.toString() !== that.$refs.oldCoach.value)
            } else {
                $('#old_coach').selectpicker('val', '')
                $('#old_coach').prop('disabled', false)
                $('#new_coach').prop('disabled', true)
                $('#new_coach').selectpicker('refresh')
            }

            $('#old_coach').selectpicker('refresh')
            $('#old_coach').selectpicker('render')
        })

        $('#old_coach').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            that.newCoaches = that.oldCoaches.filter(c => c.id.toString() !== that.$refs.oldCoach.value)
            that.oldCoach = that.$refs.oldCoach.value
        })

        $('#new_coach').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            that.newCoach = that.oldCoaches.filter(c => c.id.toString() === that.$refs.newCoach.value)[0]
        })

        $("#message").on('input', function() {
            that.message = $("#message").val()
        })
    },
    methods: {
        fetchCoaches() {
            axios.get('/coaches/active/country').then((r) => {
                this.oldCoaches = r.data.data
            })
        },
        onEmojiPicked(emoji) {
            var textBefore = this.message.substring(0, this.cursorPosition);
            var textAfter  = this.message.substring(this.cursorPosition, this.message.length);

            this.message = textBefore + emoji + textAfter
        }
    }
}
</script>
